import { useEffect, useState } from 'react';

export function useTheme() {
  const [dark, setDark] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = localStorage.getItem('dz-theme');
    if (stored === 'dark') return true;
    if (stored === 'light') return false;
    return false;
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    localStorage.setItem('dz-theme', dark ? 'dark' : 'light');
  }, [dark]);

  return { dark, toggle: () => setDark((d) => !d) };
}

export function formatPrice(cents: string | number): string {
  const n = typeof cents === 'string' ? Number(cents) : cents;
  return (n / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
